import groupBy from 'lodash/groupBy'

export type ChecklistItemData = {
  section: string
  key: string
  isChecked: boolean
}

export const createNewChecklist = (): ChecklistItemData[] => [
  { section: 'kickoff-call', key: 'attend-kickoff-call', isChecked: false },
  { section: 'kickoff-call', key: 'build-estimate', isChecked: false },
  { section: 'kickoff-call', key: 'book-review-call', isChecked: false },
  { section: 'kickoff-call', key: 'book-strategy-call', isChecked: false },
  { section: 'budget', key: 'budget', isChecked: false },
  { section: 'budget', key: 'activate-budget', isChecked: false },
  { section: 'system-setup', key: 'users', isChecked: false },
  { section: 'system-setup', key: 'crew', isChecked: false },
  { section: 'system-setup', key: 'terms', isChecked: false },
  { section: 'system-setup', key: 'divisions', isChecked: false },
  { section: 'system-setup', key: 'qbo', isChecked: false },
  { section: 'system-setup', key: 'cost-codes', isChecked: false },
  { section: 'sold-jobs', key: 'create', isChecked: false },
  { section: 'sold-jobs', key: 'schedule', isChecked: false },
  { section: 'estimates', key: 'create', isChecked: false },
  { section: 'estimates', key: 'proposal', isChecked: false },
  { section: 'train-crew', key: 'clock-in-and-out', isChecked: false },
  { section: 'train-crew', key: 'digital-job-folder', isChecked: false },
  { section: 'track-time', key: 'track-time', isChecked: false },
  { section: 'job-costing', key: 'review', isChecked: false },
  { section: 'invoicing', key: 'send', isChecked: false },
]

export type Action =
  | { type: 'CHECKMARK_CHANGED', section: string, key: string, value: boolean }
  | { type: 'CHECKLIST_LOADED', steps: ChecklistItemData[] }

export type Dispatch = (action: Action) => void

const isMatch = (item: ChecklistItemData, section: string, key: string): boolean => {
  return item.section === section && item.key === key
}

export const isItemChecked = (items: ChecklistItemData[], section: string, key: string): boolean => {
  return items.find(x => isMatch(x, section, key))?.isChecked ?? false
}

export const reducer = (state: ChecklistItemData[], action: Action): ChecklistItemData[] => {
  switch (action.type) {
    case 'CHECKMARK_CHANGED':
      return state.map(x => isMatch(x, action.section, action.key) ? { ...x, isChecked: action.value } : x)
    case 'CHECKLIST_LOADED':
      return createNewChecklist().map(x => ({ ...x, isChecked: isItemChecked(action.steps, x.section, x.key) }))
    default:
      return [...state]
  }
}

export const getSectionTotals = (items: ChecklistItemData[]): { completed: number, total: number } => {
  const grouped = groupBy(items, x => x.section)
  const keys = Object.keys(grouped)
  return {
    completed: keys.reduce((total, key) => total + (grouped[key].every(x => x.isChecked) ? 1 : 0), 0),
    total: keys.length
  }
}

export const getSectionCompletionEventData = (items: ChecklistItemData[]) => {
  const grouped = groupBy(items, x => x.section)
  const keys = Object.keys(grouped)

  const eventData: any = {}
  const userProperties: any = {}
  const userPropertyPrefix = 'success-checklist-'
  let uniqueString = ''
  let completedCount = 0
  keys.forEach(x => {
    const allChecked = grouped[x].every(x => x.isChecked)
    if (allChecked) {
      completedCount++
    }
    eventData[x] = allChecked ? 'true' : 'false'
    userProperties[`${userPropertyPrefix}${x}`] = allChecked ? 'true' : 'false'
    uniqueString += `${x}${allChecked ? 1 : 0}`
  })
  eventData['completed-count'] = completedCount
  userProperties[`${userPropertyPrefix}completed-count`] = completedCount
  return { eventData, userProperties, uniqueString }
}
